<template>
  <v-dialog
    ref="dialog"
    v-model="modaldate"
    :close-on-content-click="false"
    persistent
    width="430px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateRangeText"
        v-bind="attrs"
        :append-icon="appen ? 'mdi-calendar-multiple-check' : ''"
        :prepend-icon="!appen ? 'mdi-calendar-multiple-check' : ''"
        :label="label"
        color="primary"
        :outlined="outlined"
        dense
        readonly
        :class="{ 'search-input': hideDetails }"
        v-on="on"
      />
    </template>
    <v-row no-gutters align-content="stretch">
      <v-col cols="4" class="py-0 my-0">
        <v-list dense class="fill-height">
          <v-subheader class="present-header">
            <span class="present-title" v-text="'Preset'" />
          </v-subheader>
          <v-list-item-group v-model="optionSelected" mandatory color="primary">
            <v-list-item
              v-for="preset in presets"
              :key="preset.label"
              @click="onDateRangeChange(preset.range)"
            >
              <v-list-item-content>
                <v-list-item-title v-text="preset.label"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col cols="8">
        <v-date-picker v-model="dates" range v-bind="options" color="primary">
          <v-col>
            <ButtonCancel @click="modaldate = false" />
          </v-col>
          <v-col>
            <ButtonSuccess
              @click="
                $refs.dialog.save(dates),
                  $emit('input', dates),
                  $emit('click', false)
              "
            />
          </v-col>
        </v-date-picker>
      </v-col>
    </v-row>
  </v-dialog>
</template>
<script>
export default {
  name: "DatePickerRangeOptions",
  props: {
    mindate: {
      type: String,
      default: "false",
    },
    maxdate: {
      type: String,
      default: "false",
    },
    todayMin: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Date Range",
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    start: {
      type: Number,
      default: 0,
    },
    appen: {
      type: Boolean,
      default: true,
    },
    currentRange: {
      type: Array,
      default: null,
    },
  },
  data() {
    const self = this;
    return {
      optionSelected: 0,
      modaldate: false,
      dates: [
        this.$appFormatters.formatDateDB(new Date()),
        this.$appFormatters.formatDateDB(new Date()),
      ],
      presets: [
        {
          label: "Today",
          range: [
            self.$appFormatters.formatDateDB(new Date()),
            self.$appFormatters.formatDateDB(new Date()),
          ],
        },
        {
          label: "Yesterday",
          range: [
            self.$appFormatters.getTodayMinusDays(1),
            self.$appFormatters.getTodayMinusDays(1),
          ],
        },
        {
          label: "Last week",
          range: [
            self.$appFormatters.getTodayMinusDays(7),
            self.$appFormatters.getTodayMinusDays(1),
          ],
        },
        {
          label: "Last 15 days",
          range: [
            self.$appFormatters.getTodayMinusDays(15),
            self.$appFormatters.getTodayMinusDays(1),
          ],
        },
        {
          label: "Last 30 Days",
          range: [
            self.$appFormatters.getTodayMinusDays(30),
            self.$appFormatters.getTodayMinusDays(1),
          ],
        },
        {
          label: "Last 60 Days",
          range: [
            self.$appFormatters.getTodayMinusDays(60),
            self.$appFormatters.getTodayMinusDays(1),
          ],
        },
        {
          label: "Last 90 Days",
          range: [
            self.$appFormatters.getTodayMinusDays(90),
            self.$appFormatters.getTodayMinusDays(1),
          ],
        },
        {
          label: "Custom",
          range: [],
        },
      ],
    };
  },

  computed: {
    dateRangeText() {
      return (
        this.$appFormatters.formatDateRange(this.dates[0]) +
        " - " +
        this.$appFormatters.formatDateRange(this.dates[1])
      );
    },
    options() {
      return {
        max: this.maxdate == "false" ? "" : this.maxdate,
        min: this.mindate == "false" ? "" : this.mindate,
      };
    },
  },
  watch: {
    dates(value) {
      //Valid that the second value is bigger that bhe first one
      if (value.length === 2) {
        if (value[1] < value[0]) {
          value.splice(0, 1);
        }
      } else {
        this.optionSelected = this.presets.length - 1;
      }
    },
    currentRange(value) {
      //Valid that the second value is bigger that bhe first one
      if (value.length > 0) {
        this.dates = this.currentRange;
        this.optionSelected = 6;
      }
    },
  },
  mounted() {
    //add min date propety if there is a value
    if (this.start === 0) {
      if (this.todayMin) {
        this.dates = [
          this.$appFormatters.formatDateDB(new Date()),
          this.$appFormatters.formatDateDB(new Date()),
        ];
      } else {
        this.dates = [
          this.$appFormatters.formatDateDB(
            new Date().setFullYear(new Date().getFullYear() - 1)
          ),
          this.$appFormatters.formatDateDB(new Date()),
        ];
      }
    } else {
      this.optionSelected = this.start;
      this.onDateRangeChange(this.presets[this.start].range);
    }
    this.$emit("input", this.dates);
  },
  methods: {
    onDateRangeChange: function (t) {
      t.sort((a, b) => Date.parse(a) - Date.parse(b));
      this.dates = t;
    },
  },
};
</script>
<style lang="scss">
.present-header {
  height: 80px !important;
  vertical-align: "end";
}
.present-title {
  font-size: 30px !important;
}
</style>
